import DTO from './DTO';
import DtoType from './converters/DtoType';
import AuthorizedUserDTO from './AuthorizedUserDTO';

class AuthorizedDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'loggedIn',
        type: Boolean,
      },
      {
        name: 'loginProcess',
        type: Boolean,
      },
      {
        name: 'authorizedData',
        type: DtoType(AuthorizedUserDTO),
      },
      {
        name: 'token',
        type: String,
      },
      {
        name: 'loadingForgotPassword',
        type: Boolean,
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      loggedIn: this.loggedIn,
      loginProcess: this.loginProcess,
      authorizedData: this.authorizedData.getData(),
      token: this.token,
      loadingForgotPassword: this.loadingForgotPassword,
    };
  }
}

export default AuthorizedDTO;
